export const defaults = {
  slots: [
    {
      name: 'App Store',
      content: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: '<span class="builder-text">275,000 App Store Reviews</span>',
              style: 'Body LG',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'center',
              fontSize: '20px',
              fontFamily: '"__Heebo_7c103c", sans-serif',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: '<span class="builder-text"><span class="builder-text">4.9</span></span>',
              style: 'Heading 3',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'center',
              fontSize: '30px',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Image',
            options: {
              image:
                'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Ff93a5d63030e4eb180ece27dece2c1a4',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              lazy: false,
              fitContent: true,
              aspectRatio: 0.15,
              lockAspectRatio: false,
              noWebp: true,
              height: 15,
              width: 100,
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              width: '100%',
              minHeight: '20px',
              minWidth: '20px',
              overflow: 'hidden',
              maxWidth: '100px',
              marginLeft: 'auto',
              marginRight: 'auto',
            },
          },
        },
      ],
      width: 250,
    },
    {
      name: 'Forbes',
      content: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Image',
            options: {
              image:
                'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F59faac3e1c55476890678ca034dd95ef',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              lazy: false,
              fitContent: true,
              aspectRatio: 0.37,
              lockAspectRatio: false,
              height: 34,
              width: 92,
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              width: '100%',
              minHeight: '34px',
              minWidth: '20px',
              overflow: 'hidden',
              marginLeft: 'auto',
              marginRight: 'auto',
              maxWidth: '91px',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: '<span class="builder-text">“I got more out of BODi than I ever expected to from an app-based workout.”</span>',
              style: 'Body MD',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'center',
              marginTop: '10px',
            },
          },
        },
      ],
      width: 250,
    },
    {
      name: 'Business Insider',
      content: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Image',
            options: {
              image:
                'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fdb569fe59f464db8bfcc06172e2034a1',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              lazy: false,
              fitContent: true,
              aspectRatio: 0.418,
              lockAspectRatio: false,
              height: 28,
              width: 67,
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              width: '100%',
              minHeight: '34px',
              minWidth: '20px',
              overflow: 'hidden',
              marginLeft: 'auto',
              marginRight: 'auto',
              maxWidth: '67px',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: '<span class="builder-text"><span class="builder-text"><span class="builder-text"><span class="builder-text"><span class="builder-text">“Best Workout Apps for Beginners”</span></span></span></span></span>',
              style: 'Body MD',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'center',
              marginTop: '10px',
            },
          },
        },
      ],
      width: 280,
    },
    {
      name: 'Good Housekeeping',
      content: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Image',
            options: {
              image:
                'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F8de90e1864a7474b963511ac0f38b2d0',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              lazy: false,
              fitContent: true,
              aspectRatio: 0.222,
              lockAspectRatio: false,
              height: 28,
              width: 126,
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              width: '100%',
              minHeight: '34px',
              minWidth: '20px',
              overflow: 'hidden',
              marginLeft: 'auto',
              marginRight: 'auto',
              maxWidth: '124px',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: '<p>“Best Workout App of 2022.”</p>',
              style: 'Body MD',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'center',
              marginTop: '10px',
            },
          },
        },
      ],
      width: 250,
    },
  ],
}
